/** Utils */
function qs<T extends Element = Element>(sel: string, root: ParentNode | Document = document): T | null {
  return root.querySelector(sel) as T | null;
}
function qsa<T extends Element = Element>(sel: string, root: ParentNode | Document = document): T[] {
  return Array.from(root.querySelectorAll(sel)) as T[];
}

/** Normaliza HTML de Quill para verificar se há conteúdo "real". */
export function hasContent(html?: string): boolean {
  if (!html) return false;
  let text = html
    .replace(/<(?:p|div)[^>]*><br\s*\/?><\/(?:p|div)>/gi, " ")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > 0;
}

/** Marca estado visual de um passo (li) da checklist. */
function setStepState(stepClass: string, done: boolean) {
  const li = qs<HTMLLIElement>(`.progress-top .checklist li.${stepClass}`);
  if (!li) return;
  li.classList.toggle("done", !!done);
}

/** Recalcula qual passo fica com .active (o primeiro ainda não concluído). */
function recomputeActive() {
  const steps = qsa<HTMLLIElement>(".progress-top .checklist li");
  let firstOpen: HTMLLIElement | null = null;
  for (const li of steps) {
    if (!li.classList.contains("done") && !firstOpen) firstOpen = li;
    li.classList.remove("active");
  }
  if (firstOpen) firstOpen.classList.add("active");
}

/** ===== Handlers por seção ===== */

/** Seção 1 — Identificação dos Parceiros */
export function atualizarChecklistIdentificacao(completo: boolean) {
  setStepState("identificacao", completo);
  recomputeActive();
}

/** Seção 2 — Objeto */
export function atualizarChecklistObjeto(titulo?: string, tipo?: string, area?: string) {
  const ok = !!(titulo && titulo.trim()) && !!(tipo && tipo.trim()) && !!(area && area.trim());
  setStepState("objeto", ok);
  recomputeActive();
}

/** Seção 3 — Caracterização do Projeto (Objetivos gerais e específicos) */
export function atualizarChecklistCaracterizacao(objGerais?: string, objEspecificos?: string) {
  const ok = hasContent(objGerais) && hasContent(objEspecificos);
  setStepState("descricao", ok);
  recomputeActive();
}

/** Seção 4 — Justificativa */
export function atualizarChecklistJustificativa(just?: string) {
  const ok = hasContent(just);
  setStepState("justificativa", ok);
  recomputeActive();
}

/** Seção 5 — Descrição das Atividades */
export function atualizarChecklistDescAtividades(resUFC?: string, resParceiro?: string, conj?: string) {
  const ok = hasContent(resUFC) && hasContent(resParceiro) && hasContent(conj);
  setStepState("desc-atividades", ok);
  recomputeActive();
}

/** Seção 6 — Direitos de Propriedade Intelectual */
export function atualizarChecklistDireitosPI(direitos?: string) {
  const ok = hasContent(direitos);
  setStepState("direitos", ok);
  recomputeActive();
}

/** Seção 7 — Resultados Esperados (Metas & Indicadores) */
export function atualizarChecklistAtividades(completo: boolean) {
  setStepState("atividades", completo);
  recomputeActive();
}

/** Força um recálculo */
export function recomputeProgressUI() {
  recomputeActive();
}

/** Debounce utilitário para eventos de input/editor */
const timers = new Map<string, number>();
export function debounceKey(key: string, fn: () => void, ms = 120) {
  const t = timers.get(key);
  if (t) window.clearTimeout(t);
  const id = window.setTimeout(fn, ms);
  timers.set(key, id);
}

/** Seção — Plano de Aplicação Financeira (Orçamento) */
export function atualizarChecklistPlanoFinanceiro(completo: boolean) {
  setStepState('plano', !!completo);
  recomputeActive();
}

export function atualizarChecklistMeios(completo: boolean) {
  setStepState('meios', !!completo);
  recomputeActive();
}